/// <reference path="../../../../typings/index.d.ts" />
///<reference path="sections/main.section.ts"/>
///<reference path="../../components/baseClasses/dataMaintenanceContextBase.ts"/>


module Meevo.Plugins.YieldManagementProgram {
    export class YieldManagementProgramContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        sections: YmSectionBase[];
        selectedSection: YmSectionBase;

        get headerContent() {

            let text = '';

            if (this.selectedSection.selectedStrategy) {
                text += this.selectedSection.selectedStrategy.displayName;
            }

            if (this.selectedSection.model && this.selectedSection.model.displayName) {
                text += `: ${this.selectedSection.model.displayName}`;
            }

            if (this.selectedSection.model && this.selectedSection.model.startDate) {
                text += ` ${this.$filter('meevoDateFilter')(this.selectedSection.model.startDate)}`;

                if (this.selectedSection.model.endDate) {
                    text += ` - ${this.$filter('meevoDateFilter')(this.selectedSection.model.endDate)}`;
                }
            }

            return text;
        }

        constants: { [key: string]: any };
        model: YMProgramModel;
        selectedStrategy: any;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
                    dataService: Meevo.Components.BaseClasses.IDataService,
                    modalService: Meevo.Components.Modal.IModalService,
                    identityService: Meevo.Components.Common.IIdentityService,
                    loggingService: Meevo.Components.Logging.ILoggingService,
                    securityChecker: Meevo.Components.Common.ISecurityService,
                    trackingService: Meevo.Components.Tracking.ITrackingService,
                    $scope: angular.IScope,
                    protected $filter,
                    private _$q: ng.IQService,
                    private _busyService: Meevo.Components.Busy.IBusyService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);

            this.baseEndpoint = appSettings.API_ENDPOINTS.yieldManagementProgram;
            this.sectionTemplatePath = 'app/plugins/yieldManagementProgram/sectionViews/';
            this.entityType = 'yieldManagementProgram';
        }


        initializeSections(): void {
            this.sections.push(
                new YieldManagerStrategyMainSection(0,
                    'SECTION_YIELD_MANAGEMENT_PROGRAM_MAIN',
                    'main.html',
                    true,
                    false,
                    this.appSettings.API_ENDPOINTS.yieldManagementProgram,
                    '',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.YieldManagementProgramMain,
                    null,
                    this.securityKeys.MANAGEMENT_YIELDMANAGEMENTPROGRAM_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                ),
                new YieldManagerStrategyClientSection(1,
                    'SECTION_YIELD_MANAGEMENT_PROGRAM_CLIENTS',
                    'client.html',
                    false,
                    false,
                    this.appSettings.API_ENDPOINTS.yieldManagementProgram,
                    '',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.YieldManagementProgramClient,
                    this.appSettings,
                    this.securityKeys.MANAGEMENT_YIELDMANAGEMENTPROGRAM_TAB_CLIENTS + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE
                ),
                new YieldManagerStrategyServicesSection(2,
                    'SECTION_YIELD_MANAGEMENT_PROGRAM_SERVICES',
                    'services.html',
                    false,
                    false,
                    this.appSettings.API_ENDPOINTS.yieldManagementProgram,
                    '',
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.YieldManagementProgramService,
                    this.appSettings,
                    this.securityKeys.MANAGEMENT_YIELDMANAGEMENTPROGRAM_TAB_SERVICES + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE
                ),
            );

            if (!this.identityService.inCentralOfficeMode()) {
                this.sections.push(
                    new YieldManagerStrategyEmployeesSection(3,
                        'SECTION_YIELD_MANAGEMENT_PROGRAM_EMPLOYEES',
                        'employees.html',
                        false,
                        false,
                        this.appSettings.API_ENDPOINTS.yieldManagementProgram,
                        '',
                        this.loggingService,
                        this.dataService,
                        this.identityService,
                        Meevo.Model.NounEnum.YieldManagementProgramEmployee,
                        this.appSettings,
                        this.securityKeys.MANAGEMENT_YIELDMANAGEMENTPROGRAM_TAB_EMPLOYEES + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE
                    )
                )
            }
        }

        initializeHeader(model: any): void {
            this.businessTypeDetail = model.businessTypeDetail;
        }

        selectSection(item: Meevo.Components.BaseClasses.IDataMaintenanceSection<Meevo.Model.DataMaintenance>, subSectionContentKey?: string): void {
            switch (item.sectionId) {
                case 1:
                    this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_YIELDMANAGEMENTPROGRAM_TAB_CLIENTS);
                    break;
                case 2:
                    this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_YIELDMANAGEMENTPROGRAM_TAB_SERVICES);
                    break;
                case 3:
                    this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_YIELDMANAGEMENTPROGRAM_TAB_EMPLOYEES);
                    break;
                default:
                    this.buildCrudSecurityKeysBase(this.securityKeys.MANAGEMENT_YIELDMANAGEMENTPROGRAM_TAB_MAIN, true, false);
                    break;
            }
            super.selectSection(item, subSectionContentKey);
        }

        postSave(model: YMProgramModel): void {
            super.postSave(model);

            if (!this.identityService.inCentralOfficeMode() && this.selectedSection instanceof YieldManagerStrategyServicesSection) {
                if (model.employeeIds.length === 0) {
                    this.modalService.confirm('MESSAGE_CONFIRM_CONFIGURE_EMPLOYEE')
                        .then((confirmResult: boolean) => {
                            if (confirmResult) {
                                this.selectSection(this.sections[3]);
                            }
                        });
                }
            }
        }

        showDeleteLogic(): boolean {
            return super.showDeleteLogic() && this.selectedSection.model.homeLocationId === this.identityService.current().locationId;
        }

        showEditLogic(): boolean {
            if (this.selectedSection instanceof YieldManagerStrategyClientSection) {
                return super.showEditLogic() && this.selectedSection.canEdit();
            }

            return super.showEditLogic();
        }

        save(): angular.IPromise<any> {
            if (!this.selectedSection.modelIsValid()) {
                this._busyService.stop();

                return this._$q.resolve();
            }

            return super.save();
        }

        get showCopy(): boolean {
            return false;
        }

        get canCopy(): boolean {
            return false;
        }
    }
}
